import { LandingSource } from 'modules/finance/components/FinancialWorkspacePayroll/components/Landing/types'

export const stringBySource = (source: LandingSource) => {
  switch (source) {
    case 'payrolldatalandingpage':
      return 'Payroll Landing'
    default:
      return source
  }
}
